module.exports = __webpack_public_path__ + "img/guizhouHints_5.3f776375.jpg";